import React, { createContext, useEffect, useState } from 'react';
import { handleApiError } from '../../constants/Constants';
import {
  dashboardMonthlyUser,
  dashboardRecommandedStatus,
  dashBoardUserData,
  downloadUsers,
} from '../../api/Api';
import CommentIcon from '../../assets/images/arrowDown.png';

// Import BubbleController specifically
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Tooltip,
  Legend,
  PointElement,
  BubbleController, // <-- Import BubbleController
} from 'chart.js';

export const DashBoardContext = createContext({});
export const DashBoardContextProvider = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState('');
  const [yearList, setYearList] = useState([]);
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState('');
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [statusValue, setStatusValue] = useState(0);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [monthWiseData, setMonthWiseData] = useState([]);
  const [buttonText, setButtonText] = useState('');
  const [recommandedStatus, setRecommandedStatus] = useState();
  const [recommandedStatusBattery, setRecommandedStatusBattery] = useState();
  const [recommandedStatusCombo, setRecommandedStatusCombo] = useState();
  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);
  const [userData, setUserData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [searchData, setSearchData] = useState('');

  const labels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dataValuesForCom = monthWiseData?.map(item => {
    return item.comcount;
  });

  const dataValuesForIn = monthWiseData?.map(item => {
    return item.incount;
  });

  const handleYearChange = e => {
    setSelectedYear(e.target.value);
  };

  // Register all necessary components, including BubbleController
  ChartJS.register(
    BarElement,
    ArcElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    PointElement,
    BubbleController, // <-- Register BubbleController here
  );

  const data = {
    labels,
    datasets: [
      {
        label: ' V-Guard.com',
        data: dataValuesForCom,
        backgroundColor: 'rgba(253, 180, 38, 1)',
        borderColor: 'rgba(253, 180, 38, 1)',
        borderWidth: 0,
        borderRadius: 8,
        barThickness: 12,
      },
      {
        label: 'V-Guard.in',
        data: dataValuesForIn,
        backgroundColor: '#FF6D00',
        borderColor: '#FF6D00',
        borderWidth: 0,
        borderRadius: 8,
        barThickness: 12,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          title: context => {
            return `${context[0].label} ${selectedYear}`;
          },
          label: context => `${context.raw} Visitors`,
          labelColor: context => ({
            borderColor: context.dataset.backgroundColor,
            backgroundColor: context.dataset.backgroundColor,
          }),
        },
        displayColors: false,
        backgroundColor: '#FFF',
        titleColor: 'rgba(125, 143, 179, 1)',
        bodyColor: 'rgba(253, 180, 38, 1)',
        borderColor: 'rgba(228, 228, 233, 1)',
        borderWidth: 1,
        padding: 10,
        titleAlign: 'center',
        bodyAlign: 'center',
        titleFont: {
          size: 13,
          weight: 'normal',
        },
        bodyFont: {
          size: 16,
          weight: 'bold',
        },
      },
      legend: {
        display: true,
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          color: 'rgba(125, 143, 179, 1)',
          font: {
            size: 14,
          },
        },
      },
    },
    elements: {
      bar: {
        borderSkipped: false,
        borderRadius: 8,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          drawBorder: false,
          borderDash: [4, 4],
          color: 'rgba(228, 228, 233, 1)',
        },
        // display: false,
        beginAtZero: true,
        ticks: {
          callback: function (value, index, values) {
            return '';
          },
        },
      },
    },
  };

  /***doughnut chart */
  const [hoverIndex, setHoverIndex] = useState(null);

  const generateDynamicJson = () => {
    const startYear = 2024;
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push({
        _id: year.toString(),
        name: year.toString(),
      });
    }

    setYearList(years);
    setSelectedYear(currentYear.toString());
  };

  const viewMonthlyUserData = async () => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await dashboardMonthlyUser(selectedYear);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setErrorPopup(false);
        setMonthWiseData(getDetailData.data.data.monthlyUsers);
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage('');
        setErrorPopup(false);
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText,
        );
      }
    }
    setSpinnerStatus(false);
  };

  const viewRecommandUserData = async () => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await dashboardRecommandedStatus();
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setErrorPopup(false);
        setRecommandedStatus(getDetailData.data.data.topProducts.topInverters);
        setRecommandedStatusBattery(
          getDetailData.data.data.topProducts.topBatteries,
        );
        setRecommandedStatusCombo(
          getDetailData.data.data.topProducts.topComboProducts,
        );
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage('');
        setErrorPopup(false);
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText,
        );
      }
    }
    setSpinnerStatus(false);
  };

  const userDataList = async (page, search) => {
    setSpinnerStatus(true);
    try {
      setSpinnerStatus(true);
      const getDetailData = await dashBoardUserData(page, search);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setErrorPopup(false);
        setTotalPage(getDetailData.data.data.contactedUsers?.totalPages);
        setUserData(
          getDetailData.data.data.contactedUsers?.users.map(item => ({
            ...item,
            name: item?.userDetails?.name ? item?.userDetails?.name : '-',
            phone: item?.userDetails?.phone ? item?.userDetails?.phone : '-',
            email: item?.userDetails?.email ? item?.userDetails?.email : '-',
            state: item?.userDetails?.state ? item?.userDetails?.state : '-',
            city: item?.userDetails?.city ? item?.userDetails?.city : '-',
            comment: (
              <div className="commentSection">
                {item?.userDetails?.comment
                  ? item?.userDetails?.comment
                  : 'No comment available'}
              </div>
            ),
          })),
        );
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage('');
        setErrorPopup(false);
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText,
        );
      }
    }
    setSpinnerStatus(false);
  };

  const handleDownload = async search => {
    try {
      const response = await downloadUsers(search);
      if (response.data.statusCode === 200) {
        if (response?.data?.data?.path) {
          window.open(response.data.data.path, '_blank');
          setSuccessAlertShow(true);
          setErrorPopup(false);
          setSuccessAlertMessage(response?.data?.message);
        } else {
          setErrorPopupMessage('Download failed: file path not found');
          setErrorPopup(true);
          setSuccessAlertShow(false);
        }
      } else {
        setErrorPopupMessage(response?.data?.message || 'Download failed');
        setErrorPopup(true);
        setSuccessAlertShow(false);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText,
      );
      setErrorPopup(true);
    }
  };

  const invertersData = recommandedStatus || [];
  const totalInverters = invertersData.reduce(
    (sum, inverter) => sum + inverter.count,
    0,
  );

  const batteryData = recommandedStatusBattery || [];
  const totalBattery = batteryData.reduce(
    (sum, battery) => sum + battery.count,
    0,
  );

  const comboData = recommandedStatusCombo || [];
  const totalCombo = comboData.reduce((sum, combo) => sum + combo.count, 0);

  const dataProducts = {
    labels: recommandedStatus?.map(item => {
      return item?.modelName;
    }),
    datasets: [
      {
        data: recommandedStatus?.map(item => {
          return item?.count;
        }),
        data: invertersData?.map(inv =>
          ((inv.count / totalInverters) * 100).toFixed(1),
        ),
        backgroundColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        borderWidth: 0,
        hoverBorderWidth: 20, // <- thick border ring on hover
        borderColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        cutout: '70%',
        hoverOffset: 0, // makes hovered section pop out
      },
    ],
  };

  const dataProductsBattery = {
    labels: recommandedStatusBattery?.map(item => {
      return item?.modelName;
    }),
    datasets: [
      {
        data: recommandedStatusBattery?.map(item => {
          return item?.count;
        }),
        data: batteryData?.map(inv =>
          ((inv.count / totalBattery) * 100).toFixed(1),
        ),
        backgroundColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        borderWidth: 0,
        hoverBorderWidth: 20, // <- thick border ring on hover
        borderColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        cutout: '70%',
        hoverOffset: 0, // makes hovered section pop out
      },
    ],
  };

  const dataProductsCombo = {
    labels: recommandedStatusCombo?.map(item => {
      return item?.modelName;
    }),
    datasets: [
      {
        data: recommandedStatusCombo?.map(item => {
          return item?.count;
        }),
        data: comboData?.map(inv =>
          ((inv.count / totalCombo) * 100).toFixed(1),
        ),
        backgroundColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        borderWidth: 0,
        hoverBorderWidth: 20, // <- thick border ring on hover
        borderColor: [
          'rgba(253, 180, 38, 1)',
          'rgba(89, 211, 224, 1)',
          'rgba(78, 149, 255, 1)',
          'rgba(175, 41, 195, 1)',
          'rgba(130, 41, 255, 1)',
          'rgba(38, 70, 253, 1)',
        ],
        cutout: '70%',
        hoverOffset: 0, // makes hovered section pop out
      },
    ],
  };

  const [centerValue, setCenterValue] = useState({
    label: dataProducts?.labels,
    value: `${dataProducts?.datasets[0]?.data[0]}%`,
  });

  const [centerValueBattery, setCenterValueBattery] = useState({
    label: dataProductsBattery?.labels,
    value: `${dataProductsBattery?.datasets[0]?.data[0]}%`,
  });

  const [centerValueCombo, setCenterValueCombo] = useState({
    label: dataProductsCombo?.labels,
    value: `${dataProductsCombo?.datasets[0]?.data[0]}%`,
  });

  const optionsProducts = {
    plugins: {
      tooltip: {
        enabled: false,
        // callbacks: {
        //   label: (ctx) => `${ctx.label}: ${ctx.raw}%`,
        // },
      },
      legend: { display: false },
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      easing: 'easeOutCubic',
      duration: 200, // total chart load animation
    },
    hover: {
      animationDuration: 0, // <- remove delay on hover!
    },
    layout: {
      padding: 30, // <-- fixes clipping during hover
    },
    onHover: (event, chartElement) => {
      if (chartElement.length) {
        const index = chartElement[0].index;
        setHoverIndex(index);
        setCenterValue({
          label: dataProducts.labels[index],
          value: `${dataProducts.datasets[0].data[index]}%`,
        });
      } else {
        setHoverIndex(null);
        setCenterValue({
          label: dataProducts?.labels[0],
          value: `${dataProducts?.datasets[0]?.data[0]}%`,
        });
      }
    },
  };

  useEffect(() => {
    if (
      dataProducts?.labels?.length &&
      dataProducts?.datasets?.[0]?.data?.length &&
      !isInitialLoadDone
    ) {
      setCenterValue({
        label: dataProducts.labels[0],
        value: `${dataProducts.datasets[0].data[0]}%`,
      });
      setIsInitialLoadDone(true); // prevent re-setting after hover
    }
  }, [dataProducts, isInitialLoadDone]);

  const optionsBattery = {
    plugins: {
      tooltip: {
        enabled: false,
        // callbacks: {
        //   label: (ctx) => `${ctx.label}: ${ctx.raw}%`,
        // },
      },
      legend: { display: false },
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      easing: 'easeOutCubic',
      duration: 200, // total chart load animation
    },
    hover: {
      animationDuration: 0, // <- remove delay on hover!
    },
    layout: {
      padding: 30, // <-- fixes clipping during hover
    },
    onHover: (event, chartElement) => {
      if (chartElement.length) {
        const index = chartElement[0].index;
        setHoverIndex(index);
        setCenterValueBattery({
          label: dataProductsBattery.labels[index],
          value: `${dataProductsBattery.datasets[0].data[index]}%`,
        });
      } else {
        setHoverIndex(null);
        setCenterValueBattery({
          label: dataProductsBattery?.labels[0],
          value: `${dataProductsBattery?.datasets[0]?.data[0]}%`,
        });
      }
    },
  };

  useEffect(() => {
    if (
      dataProductsBattery?.labels?.length &&
      dataProductsBattery?.datasets?.[0]?.data?.length &&
      !isInitialLoadDone
    ) {
      setCenterValueBattery({
        label: dataProductsBattery.labels[0],
        value: `${dataProductsBattery.datasets[0].data[0]}%`,
      });
      setIsInitialLoadDone(true); // prevent re-setting after hover
    }
  }, [dataProductsBattery, isInitialLoadDone]);

  const onChangeSearch = e => {
    const value = e.target.value;
    const trimmedValue = value.replace(/^\s+|\s+$/g, '');

    // Only update search if at least one character is typed
    if (trimmedValue.length === 0) {
      setSearchData('');
      setPageCount(1);
      return;
    }

    setSearchData(value);
    setPageCount(1);
  };

  const optionsCombo = {
    plugins: {
      tooltip: {
        enabled: false,
        // callbacks: {
        //   label: (ctx) => `${ctx.label}: ${ctx.raw}%`,
        // },
      },
      legend: { display: false },
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      easing: 'easeOutCubic',
      duration: 200, // total chart load animation
    },
    hover: {
      animationDuration: 0, // <- remove delay on hover!
    },
    layout: {
      padding: 30, // <-- fixes clipping during hover
    },
    onHover: (event, chartElement) => {
      if (chartElement.length) {
        const index = chartElement[0].index;
        setHoverIndex(index);
        setCenterValueCombo({
          label: dataProductsCombo.labels[index],
          value: `${dataProductsCombo.datasets[0].data[index]}%`,
        });
      } else {
        setHoverIndex(null);
        setCenterValueCombo({
          label: dataProductsCombo?.labels[0],
          value: `${dataProductsCombo?.datasets[0]?.data[0]}%`,
        });
      }
    },
  };

  useEffect(() => {
    if (
      dataProductsCombo?.labels?.length &&
      dataProductsCombo?.datasets?.[0]?.data?.length &&
      !isInitialLoadDone
    ) {
      setCenterValueCombo({
        label: dataProductsCombo.labels[0],
        value: `${dataProductsCombo.datasets[0].data[0]}%`,
      });
      setIsInitialLoadDone(true); // prevent re-setting after hover
    }
  }, [dataProductsCombo, isInitialLoadDone]);

  useEffect(() => {
    generateDynamicJson();
    viewRecommandUserData();
  }, []);

const trimmedSearch = searchData.trim();

useEffect(() => {
  if (!trimmedSearch) {
    userDataList(pageCount, '');
    return;
  }

  const timeoutID = setTimeout(() => {
    userDataList(pageCount, trimmedSearch);
  }, 900);

  return () => clearTimeout(timeoutID);
}, [pageCount, trimmedSearch]); // now depends on trimmed search
  useEffect(() => {
    viewMonthlyUserData();
  }, [selectedYear]);

  const onPageChange = e => {
    setSpinnerStatus(true);
    setPageCount(e);
  };

  const providerValue = {
    data,
    options,
    dataProducts,
    optionsProducts,
    centerValue,
    handleYearChange,
    selectedYear,
    monthWiseData,
    yearList,
    centerValueBattery,
    centerValueCombo,
    optionsBattery,
    optionsCombo,
    dataProductsBattery,
    dataProductsCombo,
    onPageChange,
    pageCount,
    buttonText,
    spinnerStatus,
    statusValue,
    errorPopup,
    errorPopupMessage,
    hoverIndex,
    userData,
    totalPage,
    handleDownload,
    successAlertShow,
    successAlertMessage,
    setSuccessAlertShow,
    searchData,
    onChangeSearch,
    setErrorPopup,
  };
  return (
    <DashBoardContext.Provider value={providerValue}>
      {children}
    </DashBoardContext.Provider>
  );
};
